import { render, staticRenderFns } from "./Search-Result-Entry.vue?vue&type=template&id=991808e6&scoped=true&"
import script from "./Search-Result-Entry.vue?vue&type=script&lang=js&"
export * from "./Search-Result-Entry.vue?vue&type=script&lang=js&"
import style0 from "./Search-Result-Entry.vue?vue&type=style&index=0&id=991808e6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991808e6",
  null
  
)

export default component.exports